module.exports = __webpack_public_path__ + "img/cala-game.bfa4447e.png";